export default "__VITE_ASSET__90e366d0__"